// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".recruit_info .zr_logo{width:7.253rem;margin-left:calc(50% - 3.6265rem)}.recruit_info .zr_logo img{width:100%}.recruit_info .upload_box{margin-top:.26667rem;font-size:.37333rem;color:#595959;border:.02667rem dashed #d9d9d9}.recruit_info .upload_box .el-upload{width:100%}.recruit_info .upload_box .el-upload .el-upload-dragger{width:100%;height:unset;border:none}", ""]);
// Exports
module.exports = exports;
